import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { typingTimeOut } from '../../constants';

export interface Props {
  searchTerm?: string;
  onSearchChange: (search: string) => void;
}

const GlobalSearch = (props: Props): JSX.Element => {
  const [search, setSearch] = useState<string>(props.searchTerm ?? '');

  useEffect(() => {
    const timeoutId = setTimeout(
      () => props.onSearchChange(search),
      typingTimeOut
    );

    return () => clearTimeout(timeoutId);
  }, [search]);

  return (
    <form>
      <TextField
        sx={{ width: 350 }}
        label="Search"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        onKeyPress={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        InputProps={{
          endAdornment: (
            <IconButton onClick={() => setSearch('')}>
              <ClearIcon />
            </IconButton>
          )
        }}
      />
    </form>
  );
};

export default GlobalSearch;
